import { render, staticRenderFns } from "./BaseForwardLink.vue?vue&type=template&id=7e8a0ae8&scoped=true&functional=true&"
import script from "./BaseForwardLink.vue?vue&type=script&lang=ts&"
export * from "./BaseForwardLink.vue?vue&type=script&lang=ts&"
import style0 from "./BaseForwardLink.vue?vue&type=style&index=0&id=7e8a0ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7e8a0ae8",
  null
  
)

export default component.exports